import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import EmployeeDetailCard from 'components/Organisms/Employee/EmployeeRecord/ActionList/EmployeeDetailCard';
import EffectiveDateForm from 'components/Organisms/Employee/EmployeeRecord/ActionList/EffectiveDateForm';

const TerminateEmployee = ({ employeeData, handleSubmit, handleCancel, loading }) => {
  return (
    <>
      <EmployeeDetailCard employeeData={employeeData} />
      <Box mt={2}>
        <EffectiveDateForm
          heading="**Please specify any termination notes as needed below."
          label="Termination"
          btnLabel="Confirm"
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
          loading={loading}
        />
      </Box>
    </>
  );
};

TerminateEmployee.defaultProps = {
  employeeData: {},
  handleSubmit: () => {},
  handleCancel: () => {},
  loading: false,
};

TerminateEmployee.propTypes = {
  employeeData: PropTypes.shape(),
  handleSubmit: PropTypes.func,
  handleCancel: PropTypes.func,
  loading: PropTypes.bool,
};

export default TerminateEmployee;
